<template>
  <div class="carousel">
    <div
      class="carousel-slide"
      v-for="(photo, idx) in photos"
      :key="idx"
      v-show="currentIndex === idx"
    >
      <img :src="photo.src" :alt="photo.alt || `Slide ${idx+1}`" />
    </div>
    <button class="carousel-button prev" @click="prev">‹</button>
    <button class="carousel-button next" @click="next">›</button>
  </div>
</template>

<script>
export default {
  name: 'PhotoCarousel',
  props: { photos: Array },
  data: () => ({ currentIndex: 0 }),
  methods: {
    prev() { this.currentIndex = (this.currentIndex + this.photos.length - 1) % this.photos.length; },
    next() { this.currentIndex = (this.currentIndex + 1) % this.photos.length; }
  }
};
</script>

<style scoped>
.carousel {
  position: relative;
  overflow: hidden;
  max-width: 100%;
  margin: 0 auto;
}

.carousel-slide {
  display: none;
  /* center content */
  display: flex;
  align-items: center;
  justify-content: center;
  /* fixed height for consistency */
  height: 60vh;
}
.carousel-slide img {
  /* preserve full image within the box */
  max-width: 100%;
  max-height: 100%;
  object-fit: contain;
}
/* v-show leaves elements in the DOM with display none,
   so we override that when it's the active slide */
.carousel-slide[v-show="true"] {
  display: flex;
}

.carousel-button {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  background: rgba(0,0,0,0.5);
  border: none;
  color: white;
  font-size: 2rem;
  padding: 0.25rem 0.5rem;
  cursor: pointer;
  z-index: 1;
}

.carousel-button.prev {
  left: 1rem;
}

.carousel-button.next {
  right: 1rem;
}

/* Mobile tweaks */
@media (max-width: 480px) {
  .carousel-slide {
    height: 40vh;
  }
  .carousel-button {
    font-size: 1.5rem;
    padding: 0.2rem 0.4rem;
  }
}
</style>
